import { render } from "./AppNavPanel.vue?vue&type=template&id=3d04d5d8"
import script from "./AppNavPanel.vue?vue&type=script&lang=js"
export * from "./AppNavPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__